export default file => new Promise((resolve) => {
	const objectURL = URL.createObjectURL(file)
	const sound = new Audio(objectURL)
	sound.addEventListener(
		'canplaythrough',
		() => {
			URL.revokeObjectURL(objectURL)
			resolve(sound.duration)
		},
		false,
	)
})
